import type { TranslationFunctions, Translations } from '$i18n/i18n-types';
import type ERAR from '$lib/erar/spec';
import { get } from 'svelte/store';
import { idToItem, indexToSubcategory } from './stores';

const erarGradeToGradeKey: Record<ERAR.Schema.Grade, keyof Translations['er']['grade']> = {
  C: 'Common',
  U: 'Uncommon',
  R: 'Rare',
  E: 'Epic',
  L: 'Legendary',
  M: 'Mythic',
};

export function getItemName(LL: TranslationFunctions, id: number): string {
  type Key = keyof Translations['er']['items']['names'];
  return LL.er.items.names[id.toString() as Key]('{}');
}

export function getItemSubcategoryName(LL: TranslationFunctions, id: number): string {
  const key = get(idToItem).get(id)?.itemSubcategoryId ?? 'None';
  return getSubcategoryName(LL, key);
}

export function getCategoryName(LL: TranslationFunctions, id: string) {
  type Key = keyof Translations['er']['categories'];
  return LL.er.categories[id as Key]();
}

export function getSubcategoryName(LL: TranslationFunctions, itemSubcategoryId: string): string {
  type Key = keyof Translations['er']['subcategories'];
  return LL.er.subcategories[itemSubcategoryId as Key]();
}

export function getSubcategoryNameByIndex(LL: TranslationFunctions, index: number): string {
  const key = get(indexToSubcategory).get(index)?.id ?? 'None';
  return getSubcategoryName(LL, key);
}

export function getItemHelp(LL: TranslationFunctions, id: number): string {
  type Key = keyof Translations['er']['items']['help'];
  return LL.er.items.help[id.toString() as Key]();
}

export function getItemGradeName(LL: TranslationFunctions, grade: ERAR.Schema.Grade): string {
  const key = erarGradeToGradeKey[grade];
  return LL.er.grade[key]();
}

export function getItemSkillDescription(LL: TranslationFunctions, id: number): string {
  type Key = keyof Translations['er']['items']['skills'];
  const translation = LL.er.items.skills[id.toString() as Key];
  return Object.hasOwn(translation, 'desc') ? (translation as any).desc() : id.toString();
}

export function getItemSkillName(LL: TranslationFunctions, id: number): string {
  type Key = keyof Translations['er']['items']['skills'];
  const translation = LL.er.items.skills[id.toString() as Key];
  return Object.hasOwn(translation, 'title') ? (translation as any).title() : id.toString();
}
